export class SessionData {
    public static SelectedOperator;
    public static MenuIdSelected:string;
    public static Language:string;
}